export type EventqDetectionEventType = 'motion' | 'human' | 'vehicle' | 'gun';

/** Percent-based stage coordinates for a single AI detection region. */
export interface EventqDetectionBox {
  id?: string;
  trackId?: string;
  eventType: EventqDetectionEventType;
  x: number;
  y: number;
  width: number;
  height: number;
  offsetSeconds?: number;
  timestamp?: string;
}

export interface EventqDetectionBoxClick {
  box: EventqDetectionBox;
  anchorElement: HTMLElement;
}

export interface EventqDetectionBoundingBoxActivate {
  anchorElement: HTMLElement;
}

export const DETECTION_BOUNDING_BOX_ICON_SRC: Record<EventqDetectionEventType, string> = {
  motion: '/assets/events/icons/detection-box/motion.svg',
  human: '/assets/events/icons/detection-box/human.svg',
  vehicle: '/assets/events/icons/detection-box/vehicle.svg',
  gun: '/assets/events/icons/detection-box/gun.svg',
};
